// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__nhhrd","left":"StickyBox_left__2xu4-","right":"StickyBox_right__2vAqj"};